import { useRef } from "react";
import Slider from "react-slick";
import { useGetApiQuery } from "../../redux/services/apiHome";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { useLanguageTranslation } from "../../hooks/useLanguageTranslation";
import SliderNavigation from "../SliderNavigation";

const Videos = () => {
  const navigate = useNavigate();
  const { getText } = useLanguageTranslation();
  const slider = useRef();
  const { languageType } = useSelector((state) => state.homeSlice);

  const { data: videosGalleryData = [], isLoading: videosGalleryIsLoading } =
    useGetApiQuery({ url: "video-gallery", lang: languageType });

  const visibleVideos = Array.isArray(videosGalleryData)
    ? videosGalleryData.filter((item) => item?.field_display_home_page === "On")
    : [];

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    arrows: false,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 10000,
    pauseOnHover: true,
    customPaging: (i) => (
      <button>
        <span className="dot" />
      </button>
    ),
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <div className="tab-pane video-wrapper active" id="videos">
      {videosGalleryIsLoading ? (
        <div className="photo-loader sec-loader">
          <div className="loader"></div>
        </div>
      ) : visibleVideos.length === 0 ? (
        <div className="container">
          <h4 className="title4">No Video Found</h4>
        </div>
      ) : (
        <>
          <Slider {...settings} ref={slider}>
            {visibleVideos.map((item, index) => (
              <div className="card-sec" key={index}>
                <div className="img-sec">
                  <video width="100%" height="auto" controls loop muted>
                    <source
                      src={`${process.env.REACT_APP_IMAGE_URL}/neepco/sites/default/files/2024-08/${item.field_video}`}
                      type="video/mp4"
                    />
                  </video>
                </div>
                <div className="desc-sec">
                  <p className="line-clamp line-clamp-1">{item.title}</p>
                </div>
              </div>
            ))}
          </Slider>

          <div className="flex-box">
            <div className="btn-sec">
              <SliderNavigation slider={slider} section="video gallery" />
              <a
                href="#"
                className="quick-btn"
                onClick={(e) => {
                  e.preventDefault();
                  navigate("/video-gallery-detail");
                }}
                aria-label="View All Videos"
              >
                {getText("View All", "सभी देखें")}
              </a>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Videos;
